import { render } from "./product-single.vue?vue&type=template&id=94d05848&scoped=true"
import script from "./product-single.vue?vue&type=script&lang=js"
export * from "./product-single.vue?vue&type=script&lang=js"

import "./product-single.vue?vue&type=style&index=0&id=94d05848&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94d05848"]])

export default __exports__